import SatffPage from "../pages/staff/staffPage";

export const ROLE_CAPABILITIES = {
  // ============================================
  // TOCA ROLES
  // ============================================
  toca_care_manager: {
    copilot: { enabled: true, editable: false },
    my_tasks: { enabled: true, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: true, reports: false, escalation_log: true },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: true,
      billing: false,
      billing_settings: false,
      device_orders: false,
      account_insights: true,
      user_settings: true,
      admin: false,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: false,
    cross_account_access: true,
  },

  toca_nurse: {
    copilot: { enabled: true, editable: false },
    my_tasks: { enabled: true, editable: false, priority_list: false, dailies: false, out_of_range: false, nurse_tasks: true },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: true,
      billing: false,
      billing_settings: false,
      device_orders: false,
      account_insights: true,
      user_settings: true,
      admin: false,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: false,
    cross_account_access: true,
  },

  toca_admin: {
    copilot: { enabled: true, editable: false },
    my_tasks: { enabled: true, editable: false, priority_list: false, dailies: false, out_of_range: false, nurse_tasks: false },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: true,
      billing_settings: true,
      device_orders: true,
      account_insights: true,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: true,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: true,
  },

  toca_super_admin: {
    copilot: { enabled: true, editable: false },
    my_tasks: { enabled: true, editable: false, priority_list: false, dailies: false, out_of_range: false, nurse_tasks: false },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: true,
      billing_settings: true,
      device_orders: true,
      account_insights: true,
      user_settings: true,
      admin: true,
      executive_dashboard: true,
      inventory: true,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: true,
  },
  toca_nurse_admin: {
    copilot: { enabled: true, editable: false },
    my_tasks: { enabled: true, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: true },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: true,
      billing: false,
      billing_settings: false,
      device_orders: true,
      account_insights: false,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: true,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: true,
  },
  // ============================================
  // NON-TOCA BASIC ROLES
  // ============================================
  non_toca_basic_care_manager_medical_assistant: {
    copilot: { enabled: true, editable: true },
    my_tasks: { enabled: true, editable: true, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: true,
      billing: false,
      billing_settings: false,
      device_orders: false,
      account_insights: false,
      user_settings: true,
      admin: false,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: false,
    cross_account_access: false,
  },

  non_toca_basic_care_manager_nurse: {
    copilot: { enabled: true, editable: true },
    my_tasks: { enabled: true, editable: false, priority_list: false, dailies: false, out_of_range: false, nurse_tasks: true },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: true,
      billing: false,
      billing_settings: false,
      device_orders: false,
      account_insights: false,
      user_settings: true,
      admin: false,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: false,
    cross_account_access: false,
  },

  non_toca_basic_account_admin_medical_assistant: {
    copilot: { enabled: true, editable: true },
    my_tasks: { enabled: true, editable: true, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: true,
      billing: false,
      billing_settings: false,
      device_orders: false,
      account_insights: true,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },

  non_toca_basic_account_admin_nurse: {
    copilot: { enabled: true, editable: true },
    my_tasks: { enabled: true, editable: false, priority_list: false, dailies: false, out_of_range: false, nurse_tasks: true },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: true,
      billing: false,
      billing_settings: false,
      device_orders: false,
      account_insights: true,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },

  non_toca_basic_account_admin_medical_biller: {
    copilot: { enabled: true, editable: true },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: true,
      billing_settings: false,
      device_orders: false,
      account_insights: true,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },

  non_toca_basic_account_admin_physician: {
    copilot: { enabled: true, editable: true },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: true, reports: true, escalation_log: true },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: true,
      billing: false,
      billing_settings: false,
      device_orders: false,
      account_insights: true,
      user_settings: true,
      admin: false,
      executive_dashboard: false,
      inventory: false,
      case_manager: false,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },

  non_toca_basic_super_user_nurse: {
    copilot: { enabled: true, editable: true },
    my_tasks: { enabled: true, editable: false, priority_list: false, dailies: false, out_of_range: false, nurse_tasks: true },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: true,
      billing: true,
      billing_settings: false,
      device_orders: false,
      account_insights: true,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },

  non_toca_basic_super_user_medical_biller: {
    copilot: { enabled: true, editable: true },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: true,
      billing_settings: false,
      device_orders: false,
      account_insights: true,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },
  non_toca_basic_super_user_physician: {
    copilot: { enabled: true, editable: true },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: false, reports: true, escalation_log: false },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: true,
      billing_settings: false,
      device_orders: false,
      account_insights: true,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },

  // ============================================
  // NON-TOCA FULL ROLES
  // ============================================
  non_toca_full_care_manager_medical_assistant: {
    copilot: { enabled: false, editable: false },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: true, reports: true, escalation_log: true },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: false,
      billing_settings: false,
      device_orders: false,
      account_insights: false,
      user_settings: true,
      admin: false,
      executive_dashboard: false,
      inventory: false,
      case_manager: false,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: false,
    cross_account_access: false,
  },

  non_toca_full_care_manager_nurse: {
    copilot: { enabled: false, editable: false },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: true, reports: true, escalation_log: true },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: false,
      billing_settings: false,
      device_orders: false,
      account_insights: false,
      user_settings: true,
      admin: false,
      executive_dashboard: false,
      inventory: false,
      case_manager: false,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: false,
    cross_account_access: false,
  },

  non_toca_full_account_admin_medical_assistant: {
    copilot: { enabled: false, editable: false },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: true, reports: true, escalation_log: true },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: false,
      billing_settings: false,
      device_orders: false,
      account_insights: false,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },

  non_toca_full_account_admin_nurse: {
    copilot: { enabled: false, editable: false },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: true, reports: true, escalation_log: true },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: false,
      billing_settings: false,
      device_orders: false,
      account_insights: false,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },

  non_toca_full_account_admin_medical_biller: {
    copilot: { enabled: false, editable: false },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: true, reports: true, escalation_log: true },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: true,
      billing_settings: false,
      device_orders: false,
      account_insights: false,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: false,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },

  non_toca_full_super_user_physician: {
    copilot: { enabled: false, editable: false },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: true, reports: true, escalation_log: true },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: true,
      billing_settings: false,
      device_orders: false,
      account_insights: false,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: false,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },

  non_toca_full_super_user_nurse: {
    copilot: { enabled: false, editable: false },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: true, reports: true, escalation_log: true },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: true,
      billing_settings: false,
      device_orders: false,
      account_insights: false,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: true,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },

  non_toca_full_super_user_medical_biller: {
    copilot: { enabled: false, editable: false },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: true, reports: true, escalation_log: true },
    pages: {
      patient_dashboard: false,
      dashboard: true,
      my_tasks: false,
      billing: true,
      billing_settings: false,
      device_orders: false,
      account_insights: false,
      user_settings: true,
      admin: true,
      executive_dashboard: false,
      inventory: false,
      case_manager: false,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },
  patient: {
    copilot: { enabled: false, editable: false },
    my_tasks: { enabled: false, editable: false, priority_list: true, dailies: true, out_of_range: true, nurse_tasks: false },
    SatffPage: { tasks: true, reports: true, escalation_log: true },
    pages: {
      patient_dashboard: true,
      dashboard: true,
      my_tasks: true,
      billing: true,
      billing_settings: true,
      device_orders: false,
      account_insights: true,
      user_settings: true,
      admin: false,
      executive_dashboard: false,
      inventory: false,
      case_manager: false,
      patient_detail: true,
      monitor: true,
      care_plan: true,
    },
    admin: true,
    cross_account_access: false,
  },
};

// Export as default for convenience
export default ROLE_CAPABILITIES;